import { z } from 'zod';
import { STATUS_IDS } from '../../domain/combat/statuses';
import { ELEMENTS } from '../../domain/game/elements';
import { FACTIONS } from '../../domain/game/factions';

export const factionSchema = z.enum(FACTIONS);
export const elementSchema = z.enum(ELEMENTS);

export const characterStatsSchema = z.object({
  strength: z.number().int().nonnegative(),
  intelligence: z.number().int().nonnegative(),
  dexterity: z.number().int().nonnegative(),
  luck: z.number().int().nonnegative(),
});

export const activeStatusSchema = z
  .object({
    id: z.enum(STATUS_IDS),
    remainingTurns: z.number().int().positive(),
    potency: z.number().positive().optional(),
    element: elementSchema.optional(),
  })
  .superRefine((status, context) => {
    if (status.id === 'elemental_immunity' && !status.element) {
      context.addIssue({
        code: 'custom',
        path: ['element'],
        message: 'elemental_immunity requires element',
      });
    }
  });

export const inventoryStackSchema = z.object({
  itemId: z.string().min(1),
  quantity: z.number().int().positive(),
});
